module.exports = __webpack_public_path__ + "/images/ico-carrito.864fc23.svg";